const api = require("./api");

export default function checkToken() {
	return api(
		{
			url:     "/auth/token",
			method:  "get",
			headers: {
				"X-TOKEN": localStorage.getItem("token") || "",
				"X-LOGIN": localStorage.getItem("login") || ""
			}
		}
	);
}
